/* Kalyanja reels (no app, plain JS, no libraries).
   - Feature 1: "Shop the Look" carousel (sections/kj-reels-shop-the-look.liquid): every card on screen plays (muted, first 6 s loop).
   - Feature 2: product page bubble (snippets/kj-reels-bubble.liquid): shown after page load, ✕ remembered per session.
   - Feature 3: one full-screen player for both: sound + mute toggle, swipe up/down for next/prev, product card with
     size pills (sold-out sizes disabled), Add to Cart (AJAX cart + the theme's cart drawer), Buy Now (GoKwik checkout,
     the store's checkout; falls back to /checkout), View Details. Closes with ✕, Esc and the phone's back gesture.
   Reel data comes from <script type="application/json"> tags rendered by snippets/kj-reels-item-json.liquid. */
(function () {
  'use strict';
  if (window.kjReels) return;

  var CSS_URL = (function () {
    var el = document.querySelector('[data-kj-reels-bubble][data-css]');
    if (el) return el.getAttribute('data-css');
    var s = document.currentScript && document.currentScript.src;
    return s ? s.replace(/kj-reels\.js(\?.*)?$/, function (m, q) { return 'kj-reels.css' + (q || ''); }) : '';
  })();
  function ensureCss() {
    if (!CSS_URL || document.querySelector('link[href*="kj-reels.css"]')) return;
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = CSS_URL; document.head.appendChild(l);
  }
  function money(cents) { return '₹' + Math.round((Number(cents) || 0) / 100).toLocaleString('en-IN'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function readJson(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function canPlay(type) { var v = document.createElement('video'); return !!(v.canPlayType && v.canPlayType(type)); }
  var HLS_OK = canPlay('application/vnd.apple.mpegurl');
  function saveData() { var c = navigator.connection; return !!(c && (c.saveData || /2g/.test(c.effectiveType || ''))); }
  // fill a <video> with <source> tags: adaptive HLS first where natively supported, then the mp4 (browser falls back itself)
  function setSources(v, hls, mp4) {
    while (v.firstChild) v.removeChild(v.firstChild); v.removeAttribute('src');
    var list = [];
    if (HLS_OK && hls) list.push([hls, 'application/vnd.apple.mpegurl']);
    if (mp4) list.push([mp4, 'video/mp4']);
    list.forEach(function (x) { var s = document.createElement('source'); s.src = x[0]; s.type = x[1]; v.appendChild(s); });
    v.dataset.kjLoaded = '1';
    try { v.load(); } catch (e) {}
  }
  function playSafe(v) { try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} }
  function onLoaded(fn) {
    var run = function () { ('requestIdleCallback' in window) ? requestIdleCallback(fn, { timeout: 2000 }) : setTimeout(fn, 600); };
    if (document.readyState === 'complete') run(); else window.addEventListener('load', run);
  }

  /* ---------------- Feature 3: player ---------------- */
  var ICON = {
    close: '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    soundOn: '<svg viewBox="0 0 24 24"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12"/></svg>',
    soundOff: '<svg viewBox="0 0 24 24"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M17 9l5 5M22 9l-5 5"/></svg>',
    up: '<svg viewBox="0 0 24 24"><path d="M6 15l6-6 6 6"/></svg>',
    down: '<svg viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg>',
    play: '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>'
  };
  var P = null;            // player DOM refs
  var list = [], idx = 0, muted = false, variantId = 0, lastFocus = null, pushed = false, onCloseCb = null;

  function build() {
    if (P) return P;
    ensureCss();
    var root = document.createElement('div');
    root.className = 'kj-reels-pl';
    root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true'); root.setAttribute('aria-label', 'Product video');
    root.innerHTML =
      '<div class="kj-reels-pl__box">' +
        '<div class="kj-reels-pl__stage">' +
          '<div class="kj-reels-pl__bg" aria-hidden="true"></div>' +
          '<video class="kj-reels-pl__pv" muted loop playsinline disablepictureinpicture aria-hidden="true"></video>' +
          '<video class="kj-reels-pl__video" playsinline loop preload="auto" disablepictureinpicture></video>' +
          '<div class="kj-reels-pl__spin" aria-hidden="true"></div>' +
          '<div class="kj-reels-pl__bar"><i></i></div>' +
          '<div class="kj-reels-pl__top">' +
            '<button type="button" class="kj-reels-pl__btn" data-kj-pl-mute aria-label="Mute">' + ICON.soundOn + '</button>' +
            '<div class="kj-reels-pl__title" data-kj-pl-title></div>' +
            '<span class="kj-reels-pl__count" data-kj-pl-count></span>' +
            '<button type="button" class="kj-reels-pl__btn" data-kj-pl-close aria-label="Close">' + ICON.close + '</button>' +
          '</div>' +
          '<div class="kj-reels-pl__nav" data-kj-pl-nav>' +
            '<button type="button" class="kj-reels-pl__btn" data-kj-pl-prev aria-label="Previous video">' + ICON.up + '</button>' +
            '<button type="button" class="kj-reels-pl__btn" data-kj-pl-next aria-label="Next video">' + ICON.down + '</button>' +
          '</div>' +
          '<div class="kj-reels-pl__paused" aria-hidden="true">' + ICON.play + '</div>' +
          '<div class="kj-reels-pl__hint" data-kj-pl-hint>Swipe up for the next look</div>' +
        '</div>' +
        '<div class="kj-reels-pl__card" data-kj-pl-card></div>' +
      '</div>';
    root.style.display = 'none'; // hidden until open() (prime() may build it early, on the first touch)
    document.body.appendChild(root);
    P = {
      root: root, box: root.querySelector('.kj-reels-pl__box'), stage: root.querySelector('.kj-reels-pl__stage'),
      bg: root.querySelector('.kj-reels-pl__bg'), video: root.querySelector('.kj-reels-pl__video'), pv: root.querySelector('.kj-reels-pl__pv'), bar: root.querySelector('.kj-reels-pl__bar i'),
      mute: root.querySelector('[data-kj-pl-mute]'), title: root.querySelector('[data-kj-pl-title]'),
      count: root.querySelector('[data-kj-pl-count]'), nav: root.querySelector('[data-kj-pl-nav]'),
      hint: root.querySelector('[data-kj-pl-hint]'), card: root.querySelector('[data-kj-pl-card]')
    };
    // click outside the box (desktop) closes
    root.addEventListener('click', function (e) { if (e.target === root) close(); });
    root.querySelector('[data-kj-pl-close]').addEventListener('click', function () { close(); });
    P.mute.addEventListener('click', function () { setMuted(!muted); });
    root.querySelector('[data-kj-pl-prev]').addEventListener('click', function () { go(-1); });
    root.querySelector('[data-kj-pl-next]').addEventListener('click', function () { go(1); });
    // tap on the video = pause / play
    P.video.addEventListener('click', function () {
      if (P.video.paused) { playSafe(P.video); root.classList.remove('is-paused'); }
      else { P.video.pause(); root.classList.add('is-paused'); }
    });
    P.video.addEventListener('timeupdate', function () {
      var d = P.video.duration; P.bar.style.width = d ? (P.video.currentTime / d * 100) + '%' : '0';
    });
    // swipe up / down (only on the video area, so the size row can still scroll sideways)
    var y0 = null, x0 = null, t0 = 0;
    P.stage.addEventListener('touchstart', function (e) { if (e.touches.length !== 1) return; y0 = e.touches[0].clientY; x0 = e.touches[0].clientX; t0 = Date.now(); }, { passive: true });
    P.stage.addEventListener('touchend', function (e) {
      if (y0 === null) return;
      var t = e.changedTouches[0], dy = t.clientY - y0, dx = t.clientX - x0; y0 = null;
      if (Math.abs(dy) > 55 && Math.abs(dy) > Math.abs(dx) * 1.2 && Date.now() - t0 < 900) { go(dy < 0 ? 1 : -1); }
    }, { passive: true });
    // the page behind must not scroll while the player is open
    root.addEventListener('touchmove', function (e) { if (!e.target.closest('.kj-reels-pl__sizes')) e.preventDefault(); }, { passive: false });
    var wheelLock = 0;
    P.stage.addEventListener('wheel', function (e) {
      e.preventDefault(); var now = Date.now(); if (now - wheelLock < 600 || Math.abs(e.deltaY) < 20) return;
      wheelLock = now; go(e.deltaY > 0 ? 1 : -1);
    }, { passive: false });
    return P;
  }

  function setMuted(m) {
    muted = m; if (!P) return;
    P.video.muted = m;
    P.mute.innerHTML = m ? ICON.soundOff : ICON.soundOn;
    P.mute.setAttribute('aria-label', m ? 'Unmute' : 'Mute');
    if (!m) playSafe(P.video);
  }

  // Instant start (like Whatmore): the clip that was already playing on the card / bubble (or its cached poster) fills
  // the screen at once in a back layer, a small loader shows, and the full video fades in on top as soon as it plays.
  function reelKey(r) { return r.video.hls || r.video.mp4 || ''; }
  function loadVideo(r, seed) {
    var v = P.video, pv = P.pv, key = reelKey(r);
    P.stage.classList.add('is-loading');
    var bgUrl = (seed && seed.poster) || r.video.poster || '';
    P.bg.style.backgroundImage = bgUrl ? 'url("' + bgUrl.replace(/"/g, '%22') + '")' : 'none';
    pv.pause();
    if (seed && seed.currentSrc && seed.readyState >= 2) {
      pv.poster = seed.poster || r.video.poster || '';
      if (pv.currentSrc !== seed.currentSrc) { while (pv.firstChild) pv.removeChild(pv.firstChild); pv.src = seed.currentSrc; }
      try { pv.currentTime = seed.currentTime || 0; } catch (e) {}
      playSafe(pv);
    } else {
      while (pv.firstChild) pv.removeChild(pv.firstChild); pv.removeAttribute('src'); try { pv.load(); } catch (e) {}
      pv.poster = (seed && seed.poster) || r.video.poster || '';
    }
    v.pause(); v.poster = '';
    // continue from the second the card clip had reached (the preview clip is the start of the same video)
    var startAt = (seed && seed.readyState >= 2 && seed.currentTime) ? seed.currentTime : 0;
    if (v.dataset.kjKey !== key) { setSources(v, r.video.hls, r.video.mp4); v.dataset.kjKey = key; }
    var seek = function () { try { if (!v.duration || startAt < v.duration - 1) v.currentTime = startAt; } catch (e) {} };
    if (v.readyState >= 1) seek(); else v.addEventListener('loadedmetadata', function once() { v.removeEventListener('loadedmetadata', once); seek(); });
    v.muted = muted;
    var token = {}; P.loadToken = token;
    var ready = function () {
      v.removeEventListener('playing', ready);
      if (P.loadToken !== token) return;
      P.stage.classList.remove('is-loading');
      setTimeout(function () { if (P.loadToken === token) pv.pause(); }, 300);
    };
    v.addEventListener('playing', ready);
    var p = v.play();
    if (p && p.catch) p.catch(function () { // browser refused sound (e.g. some in-app browsers): play muted
      if (!v.muted) { setMuted(true); playSafe(v); }
    });
    P.root.classList.remove('is-paused');
    // warm the next reel's poster so a swipe also starts with a picture
    var nx = list[(idx + 1) % list.length]; if (nx && nx !== r && nx.video.poster) { var im = new Image(); im.src = nx.video.poster; }
  }
  // finger touched a card / the bubble: start downloading that full video before the tap ends
  function prime(r) {
    if (!r || !r.video) return;
    build();
    var v = P.video, key = reelKey(r);
    if (!key || v.dataset.kjKey === key) return;
    v.muted = true; setSources(v, r.video.hls, r.video.mp4); v.dataset.kjKey = key;
  }

  function variantsOf(prod) { return (prod.variants || []).filter(function (v) { return v && v.id; }); }

  function renderCard(r) {
    var p = r.product, vs = variantsOf(p);
    var single = vs.length <= 1 && (!vs[0] || /^default title$/i.test(vs[0].title));
    var pick = vs.filter(function (v) { return v.id === p.selected && v.available; })[0] || vs.filter(function (v) { return v.available; })[0] || null;
    variantId = single && pick ? pick.id : 0;
    var shown = pick || vs[0] || { price: 0, compare: 0 };
    var sizes = '';
    if (!single) {
      sizes = vs.map(function (v) {
        return '<button type="button" class="kj-reels-pl__size" data-id="' + v.id + '"' + (v.available ? '' : ' disabled aria-disabled="true" title="Sold out"') + '>' + esc(v.title) + '</button>';
      }).join('');
    }
    P.card.innerHTML =
      '<div class="kj-reels-pl__prod">' +
        (p.image ? '<img class="kj-reels-pl__img" src="' + esc(p.image) + '" alt="" width="52" height="66">' : '') +
        '<div class="kj-reels-pl__info"><p class="kj-reels-pl__name">' + esc(p.title) + '</p><span class="kj-reels-price" data-kj-pl-price></span></div>' +
        '<a class="kj-reels-pl__view" href="' + esc(p.url) + '">View Details</a>' +
      '</div>' +
      '<div class="kj-reels-pl__sizes" role="group" aria-label="Size"' + (single ? ' hidden' : '') + '>' + sizes + '</div>' +
      '<p class="kj-reels-pl__msg" data-kj-pl-msg hidden></p>' +
      '<div class="kj-reels-pl__acts">' +
        '<button type="button" class="kj-reels-pl__add" data-kj-pl-add>Add to Cart</button>' +
        '<button type="button" class="kj-reels-pl__buy" data-kj-pl-buy data-gokwik-processed="true">Buy Now</button>' +
      '</div>';
    setPrice(shown);
    var anyAvail = vs.some(function (v) { return v.available; });
    if (!anyAvail) {
      P.card.querySelectorAll('[data-kj-pl-add], [data-kj-pl-buy]').forEach(function (b) { b.disabled = true; });
      P.card.querySelector('[data-kj-pl-add]').textContent = 'Sold out';
    }
    P.card.querySelectorAll('.kj-reels-pl__size').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        variantId = Number(b.getAttribute('data-id'));
        P.card.querySelectorAll('.kj-reels-pl__size').forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var v = vs.filter(function (x) { return x.id === variantId; })[0]; if (v) setPrice(v);
        msg('');
      });
    });
    P.card.querySelector('[data-kj-pl-add]').addEventListener('click', function (e) { addToCart(e.currentTarget); });
    P.card.querySelector('[data-kj-pl-buy]').addEventListener('click', function (e) { buyNow(e, e.currentTarget); });
  }
  function setPrice(v) {
    var el = P.card.querySelector('[data-kj-pl-price]'); if (!el) return;
    var html = '<span class="kj-reels-price__now">' + money(v.price) + '</span>';
    if (v.compare > v.price) {
      html += '<s class="kj-reels-price__mrp">' + money(v.compare) + '</s><span class="kj-reels-price__off">' + Math.floor((v.compare - v.price) * 100 / v.compare) + '% OFF</span>';
    }
    el.innerHTML = html;
  }
  function msg(t) { var m = P.card.querySelector('[data-kj-pl-msg]'); if (!m) return; m.textContent = t; m.hidden = !t; }
  function needSize() {
    if (variantId) return false;
    msg('Please select a size');
    var row = P.card.querySelector('.kj-reels-pl__sizes'); if (row) { row.animate && row.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 260 }); }
    return true;
  }
  function busy(btn, on, text) { btn.classList.toggle('is-busy', on); if (text) btn.textContent = text; }

  function addToCart(btn) {
    if (needSize()) return;
    busy(btn, true, 'Adding…');
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        var upd = window.sharedFunctions && window.sharedFunctions.updateSidebarCart;
        if (upd && document.querySelector('#halo-cart-sidebar')) {
          close(function () { try { upd(cart); } catch (e) {} setTimeout(function () { document.body.classList.add('cart-sidebar-show'); }, 120); });
        } else {
          location.href = '/cart';
        }
      })
      .catch(function (err) {
        busy(btn, false, 'Add to Cart');
        msg((err && (err.description || err.message)) || 'Could not add to cart. Please try again.');
      });
  }

  function buyNow(e, btn) {
    if (needSize()) return;
    busy(btn, true, 'Please wait…');
    var id = variantId;
    // the store's checkout is GoKwik: use its own buy-now call (same as the product page sticky bar)
    if (typeof window.onBuyNowClick === 'function') {
      close(function () { try { window.onBuyNowClick(e || new Event('click'), false, [{ id: id, quantity: 1 }]); } catch (err) { location.href = '/cart'; } });
      return;
    }
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw r; location.href = '/checkout'; })
      .catch(function () { busy(btn, false, 'Buy Now'); msg('Could not start checkout. Please try again.'); });
  }

  var pendingSeed = null;
  function show(i, dir) {
    if (!list.length) return;
    var seed = pendingSeed; pendingSeed = null;
    idx = (i + list.length) % list.length;
    var r = list[idx];
    P.title.innerHTML = esc(r.title || r.product.title) + (r.views ? '<span class="kj-reels-pl__views">· ' + esc(r.views) + ' views</span>' : '');
    P.count.textContent = list.length > 1 ? (idx + 1) + ' / ' + list.length : '';
    P.nav.hidden = list.length < 2;
    P.hint.hidden = list.length < 2;
    var v = P.video;
    if (dir) {
      v.classList.add(dir > 0 ? 'is-out-up' : 'is-out-down');
      setTimeout(function () { v.classList.remove('is-out-up', 'is-out-down'); loadVideo(r, null); }, 180);
    } else { loadVideo(r, seed); }
    renderCard(r);
  }
  function go(d) { if (list.length > 1) { show(idx + d, d); if (P.hint) P.hint.classList.add('is-gone'); } }

  function onKey(e) {
    if (!P || !P.root.isConnected) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    else if (e.key === 'ArrowDown') { e.preventDefault(); go(1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); go(-1); }
    else if (e.key === 'Tab') { // keep focus inside the dialog
      var f = P.root.querySelectorAll('button:not([disabled]), a[href]'); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }
  function onPop() { if (pushed) { pushed = false; teardown(); } }

  function open(items, start, opts) {
    if (!items || !items.length) return;
    build();
    list = items; muted = false; onCloseCb = opts && opts.onClose; pendingSeed = (opts && opts.from) || null;
    lastFocus = document.activeElement;
    pauseBackground(true);
    document.documentElement.classList.add('kj-reels-lock');
    P.root.style.display = '';
    requestAnimationFrame(function () { P.root.classList.add('is-in'); });
    P.hint.classList.remove('is-gone');
    clearTimeout(P.hintT); P.hintT = setTimeout(function () { P.hint.classList.add('is-gone'); }, 2500);
    setMuted(false);
    show(start || 0, 0);
    document.addEventListener('keydown', onKey);
    // phone back gesture closes the player instead of leaving the page
    try { history.pushState({ kjReels: 1 }, ''); pushed = true; window.addEventListener('popstate', onPop); } catch (e) { pushed = false; }
    setTimeout(function () { var c = P.root.querySelector('[data-kj-pl-close]'); if (c) c.focus({ preventScroll: true }); }, 60);
  }
  var afterClose = null;
  function close(cb) {
    if (!P || !P.root.classList.contains('is-in')) { if (cb) cb(); return; }
    afterClose = cb || null;
    if (pushed) { history.back(); } // popstate → teardown
    else teardown();
  }
  function teardown() {
    if (!P) return;
    window.removeEventListener('popstate', onPop);
    document.removeEventListener('keydown', onKey);
    P.loadToken = null;
    [P.video, P.pv].forEach(function (x) { x.pause(); while (x.firstChild) x.removeChild(x.firstChild); x.removeAttribute('src'); try { x.load(); } catch (e) {} });
    delete P.video.dataset.kjKey;
    P.root.classList.remove('is-in', 'is-paused');
    document.documentElement.classList.remove('kj-reels-lock');
    P.root.style.display = 'none';
    pauseBackground(false);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    var cb = afterClose; afterClose = null;
    if (onCloseCb) { try { onCloseCb(); } catch (e) {} }
    if (cb) cb();
  }

  /* pause the small looping videos behind the player, resume after */
  var bgPaused = [];
  function pauseBackground(on) {
    if (on) {
      bgPaused = [];
      document.querySelectorAll('.kj-reels-card__video, .kj-reels-bubble__video').forEach(function (v) { if (!v.paused) { v.pause(); bgPaused.push(v); } });
    } else {
      bgPaused.forEach(function (v) { if (v.isConnected && v.dataset.kjVisible !== '0') playSafe(v); }); bgPaused = [];
    }
  }

  window.kjReels = { open: open, close: close };

  /* ---------------- Feature 1: carousel ---------------- */
  function initCarousel(sec) {
    if (sec.dataset.kjReady) return; sec.dataset.kjReady = '1';
    var cards = [].slice.call(sec.querySelectorAll('.kj-reels-card'));
    var items = cards.map(function (c) { var j = c.querySelector('[data-kj-reels-item]'); return j ? readJson(j) : null; });
    sec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-kj-reels-open]'); if (!b) return;
      var i = Number(b.getAttribute('data-kj-reels-open'));
      var good = items.filter(Boolean), start = good.indexOf(items[i]);
      open(good, start < 0 ? 0 : start, { from: b.querySelector('video') });
    });
    sec.addEventListener('touchstart', function (e) {
      var b = e.target.closest && e.target.closest('[data-kj-reels-open]'); if (!b) return;
      prime(items[Number(b.getAttribute('data-kj-reels-open'))]);
    }, { passive: true });
    var vids = sec.querySelectorAll('.kj-reels-card__video');
    if (!('IntersectionObserver' in window) || saveData()) return; // posters only on data-saver / old browsers
    // start after the page has loaded so the videos never compete with the first screen.
    // Like Whatmore: every card that is even partly on screen plays; cards that leave the screen pause.
    // Cards loop only their first PREVIEW_SEC seconds (the full video plays in the full-screen player), which keeps
    // the data used by the row small.
    var PREVIEW_SEC = 6;
    vids.forEach(function (v) {
      if (v.dataset.preview) return; // a real preview clip is already short
      v.addEventListener('timeupdate', function () { if (v.currentTime > PREVIEW_SEC) { try { v.currentTime = 0; } catch (e) {} } });
    });
    onLoaded(function () {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) {
            v.dataset.kjVisible = '1';
            if (!v.dataset.kjLoaded) { if (v.dataset.preview) setSources(v, '', v.dataset.preview); else setSources(v, v.dataset.hls, v.dataset.mp4); }
            if (!document.documentElement.classList.contains('kj-reels-lock')) playSafe(v);
          } else {
            v.dataset.kjVisible = '0';
            if (!v.paused) v.pause();
          }
        });
      }, { threshold: 0, rootMargin: '0px 40px 0px 40px' });
      vids.forEach(function (v) { io.observe(v); });
    });
  }

  /* ---------------- Feature 2: product page bubble ---------------- */
  var BUBBLE_KEY = 'kjReelsBubbleClosed';
  function initBubble(b) {
    if (b.dataset.kjReady) return; b.dataset.kjReady = '1';
    try { if (sessionStorage.getItem(BUBBLE_KEY) === '1') { b.remove(); return; } } catch (e) {}
    var j = b.querySelector('[data-kj-reels-bubble-items]'); var items = j ? readJson(j) : null;
    if (!items || !items.length) { b.remove(); return; }
    var v = b.querySelector('video');
    onLoaded(function () {
      ensureCss();
      v.poster = items[0].video.poster || '';
      if (!saveData()) { if (b.dataset.preview) setSources(v, '', b.dataset.preview); else setSources(v, items[0].video.hls, items[0].video.mp4); }
      b.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { b.classList.add('is-in'); }); });
      if (!saveData()) playSafe(v);
    });
    var ob = b.querySelector('[data-kj-reels-bubble-open]');
    ob.addEventListener('touchstart', function () { prime(items[0]); }, { passive: true });
    ob.addEventListener('click', function () { open(items, 0, { from: v }); });
    b.querySelector('[data-kj-reels-bubble-close]').addEventListener('click', function (e) {
      e.stopPropagation();
      try { sessionStorage.setItem(BUBBLE_KEY, '1'); } catch (err) {}
      v.pause(); b.classList.remove('is-in'); setTimeout(function () { b.remove(); }, 300);
    });
  }

  function init() {
    document.querySelectorAll('[data-kj-reels-carousel]').forEach(initCarousel);
    document.querySelectorAll('[data-kj-reels-bubble]').forEach(initBubble);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // theme editor: sections added / re-rendered
  document.addEventListener('shopify:section:load', init);
})();
